/* Funventory global script: loaded on every page from layout/theme.liquid */
(function () {
  /* ---------------------------------------------------------------
     1. Menu: tag top-level items whose dropdown is a plain list of links
        (no column headings) with .fv-small-dd. CSS uses the tag to hide
        Horizon's full-width backdrop behind the compact panel.
        Horizon re-renders the header after load (which strips the tag),
        so a MutationObserver re-applies it whenever the header changes.
     --------------------------------------------------------------- */
  function tagSmallDropdowns() {
    document.querySelectorAll('.menu-list__list-item').forEach(function (item) {
      var submenu = item.querySelector(':scope > .menu-list__submenu');
      var small = !!submenu && !submenu.querySelector('.mega-menu__link--parent');
      if (item.classList.contains('fv-small-dd') !== small) item.classList.toggle('fv-small-dd', small);
    });
  }

  var tagQueued = false;
  function queueTag() {
    if (tagQueued) return;
    tagQueued = true;
    requestAnimationFrame(function () {
      tagQueued = false;
      tagSmallDropdowns();
    });
  }

  function watchHeader() {
    tagSmallDropdowns();
    var target = document.getElementById('header-group') || document.body;
    new MutationObserver(queueTag).observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchHeader);
  } else {
    watchHeader();
  }
  document.addEventListener('shopify:section:load', queueTag);
  window.addEventListener('load', queueTag);

  /* ---------------------------------------------------------------
     2. Product cards: Add to cart without leaving the page.
        - the button shows "Adding…" while a round thumbnail of the product
          flies in an arc to the cart icon
        - the item is added in the background at the same time
        - when the thumbnail lands: the button shows "Added ✓", the cart icon
          bounces and Horizon's cart drawer slides in from the right
        Uses the same cart event Horizon's own product forms use, so the
        cart bubble and drawer contents update themselves.
     --------------------------------------------------------------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MIN_ADDING_MS = 600; /* keeps "Adding…" readable even when animations are off */

  /* Horizon declares its settings as a top-level `const Theme`, which is a shared global
     but not a property of window, so read it by name. */
  function routes() {
    var r = (typeof Theme !== 'undefined' && Theme && Theme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      add: r.cart_add_url || root + 'cart/add.js',
      cart: r.cart_url || root + 'cart',
    };
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function visibleCartIcon() {
    var icons = document.querySelectorAll('.header-actions__cart-icon');
    for (var i = 0; i < icons.length; i++) {
      var rect = icons[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return icons[i];
    }
    return null;
  }

  /* Self-contained fly-to-cart: returns a promise that resolves when the thumbnail lands. */
  function flyToCart(card) {
    return new Promise(function (resolve) {
      if (reduceMotion || !document.body.animate) return resolve();
      var img = card.querySelector('.fvpc__slide.is-active') || card.querySelector('.fvpc__slide');
      var box = card.querySelector('.fvpc__img');
      var icon = visibleCartIcon();
      var src = img && (img.currentSrc || img.src);
      if (!box || !icon || !src) return resolve();

      var s = box.getBoundingClientRect();
      var d = icon.getBoundingClientRect();
      var size = Math.max(56, Math.min(96, s.width * 0.35));
      var startX = s.left + s.width / 2 - size / 2;
      var startY = s.top + s.height / 2 - size / 2;
      var dx = d.left + d.width / 2 - (startX + size / 2);
      var dy = d.top + d.height / 2 - (startY + size / 2);

      var fly = document.createElement('div');
      fly.setAttribute('aria-hidden', 'true');
      fly.style.cssText =
        'position:fixed;left:' + startX + 'px;top:' + startY + 'px;width:' + size + 'px;height:' + size + 'px;' +
        'border-radius:50%;background:#fff center/cover no-repeat;border:3px solid #fff;' +
        'box-shadow:0 10px 28px rgba(14,37,102,.28);z-index:2147483647;pointer-events:none;will-change:transform,opacity;';
      fly.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
      document.body.appendChild(fly);

      /* Quadratic curve: lifts up first, then swoops into the cart icon. */
      var cx = dx * 0.35;
      var cy = Math.min(dy, 0) - Math.max(120, Math.abs(dx) * 0.25);
      var frames = [];
      var steps = 16;
      for (var i = 0; i <= steps; i++) {
        var t = i / steps;
        var x = 2 * (1 - t) * t * cx + t * t * dx;
        var y = 2 * (1 - t) * t * cy + t * t * dy;
        var scale = i === 0 ? 0.6 : (t < 0.15 ? 1.1 : 1.1 - 0.85 * ((t - 0.15) / 0.85));
        frames.push({
          transform: 'translate(' + x + 'px,' + y + 'px) scale(' + scale.toFixed(3) + ')',
          opacity: t < 0.9 ? 1 : 1 - (t - 0.9) * 6,
        });
      }

      var anim = fly.animate(frames, { duration: 800, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' });
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        fly.remove();
        icon.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(.92)' }, { transform: 'scale(1)' }],
          { duration: 420, easing: 'ease-out' }
        );
        resolve();
      }
      anim.onfinish = finish;
      setTimeout(finish, 1200);
    });
  }

  function openCartDrawer() {
    var themeDrawer = document.getElementById('cart-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function') {
      if (!themeDrawer.isOpen) themeDrawer.open();
      return true;
    }
    return false;
  }

  function setButton(btn, state, text) {
    if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
    btn.classList.remove('is-adding', 'is-added', 'is-error');
    if (state) btn.classList.add('is-' + state);
    btn.textContent = text || btn.dataset.label;
    btn.setAttribute('aria-busy', state === 'adding' ? 'true' : 'false');
  }

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var card = form.closest('.fvpc');
    if (!card || (form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

    event.preventDefault();
    var btn = form.querySelector('.fvpc__btn');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    setButton(btn, 'adding', 'Adding…');

    /* Start the flight straight away so it feels instant. "Adding…" stays on the button
       until the thumbnail lands (and for at least MIN_ADDING_MS). */
    var landed = Promise.all([flyToCart(card), wait(MIN_ADDING_MS)]);

    var r = routes();
    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', '1');
    var quantity = Number(formData.get('quantity')) || 1;
    var sectionIds = Array.prototype.map
      .call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; })
      .filter(Boolean);
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    /* Horizon's cart events are optional: if they fail to load, the item is still added
       and the drawer still opens. */
    var CartLinesUpdateEvent = null;
    var CartErrorEvent = null;
    var deferred = null;
    try {
      var events = await import('@shopify/events');
      CartLinesUpdateEvent = events.CartLinesUpdateEvent;
      CartErrorEvent = events.CartErrorEvent;
      deferred = CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(formData.get('id')), quantity: quantity }],
          promise: deferred.promise,
        })
      );
    } catch (e) {
      console.warn('[fv-product-card] cart events unavailable', e);
    }

    var added;
    try {
      var addResponse = await fetch(r.add, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData,
      });
      added = await addResponse.json();
    } catch (error) {
      /* The add request itself failed (network), so nothing was added: fall back to a normal submit. */
      console.error('[fv-product-card] add request failed, falling back to a normal submit', error);
      if (deferred) deferred.reject(error);
      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    var cart = null;
    try {
      cart = await fetch(r.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (res) { return res.json(); });
    } catch (e) {
      console.warn('[fv-product-card] could not refresh cart', e);
    }

    if (added && added.status) {
      if (CartErrorEvent) form.dispatchEvent(new CartErrorEvent({ error: added.message || 'Add to cart failed', code: 'INVALID' }));
      if (deferred && cart) {
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: true, items: cart.items, source: 'fv-product-card', itemCount: 0 },
        });
      }
      setButton(btn, 'error', added.description || added.message || 'Could not add');
      setTimeout(function () { setButton(btn); btn.disabled = false; }, 2500);
      return;
    }

    /* Keep "Adding…" until the thumbnail lands, then confirm. */
    await landed;
    setButton(btn, 'added', 'Added ✓');

    if (deferred && cart) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'fv-product-card',
          sourceId: 'fv-product-card',
          itemCount: quantity,
          sections: added && added.sections,
          didError: false,
        },
      });
    }

    setTimeout(function () {
      if (!openCartDrawer()) window.location.href = r.cart;
    }, reduceMotion ? 0 : 250);
    setTimeout(function () { setButton(btn); btn.disabled = false; }, 1500);
  });

  /* ---------------------------------------------------------------
     3. Free delivery: toast + cart drawer tag.
        Whenever the cart changes anywhere on the site (product cards,
        product pages, quantity changes in the cart drawer), the cart
        total is re-checked.
        - Toast: shown the moment the total goes from below the threshold
          to at or above it (once per crossing, not on every page).
        - Tag: a "Free shipping" pill next to the cart drawer title while
          the total is at or above the threshold; removed below it.
     --------------------------------------------------------------- */
  var FREE_DELIVERY_THRESHOLD = 5000 * 100; /* Rs 5,000 in paisa (Shopify cart totals are in cents) */
  var TOTAL_KEY = 'fvCartTotal';

  function readTotal() {
    try { var v = sessionStorage.getItem(TOTAL_KEY); return v === null ? null : Number(v); } catch (e) { return null; }
  }
  function writeTotal(v) {
    try { sessionStorage.setItem(TOTAL_KEY, String(v)); } catch (e) {}
  }

  var TRUCK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>';

  var fvStyleAdded = false;
  function addFreeDeliveryStyles() {
    if (fvStyleAdded) return;
    fvStyleAdded = true;
    var css =
      /* toast */
      '.fv-toast{position:fixed;inset:auto;left:50%;bottom:28px;margin:0;transform:translate(-50%,16px);opacity:0;' +
      'display:flex;align-items:center;gap:14px;max-width:min(92vw,460px);padding:14px 16px 14px 14px;border:0;border-radius:20px;' +
      'background:#2FA65A;color:#fff;box-shadow:0 16px 40px rgba(14,37,102,.28);font-family:Nunito,system-ui,-apple-system,sans-serif;' +
      'z-index:2147483647;transition:opacity .3s ease,transform .3s ease;overflow:visible}' +
      '.fv-toast.is-in{opacity:1;transform:translate(-50%,0)}' +
      '.fv-toast__icon{flex:0 0 44px;height:44px;border-radius:50%;background:rgba(255,255,255,.2);display:grid;place-items:center}' +
      '.fv-toast__icon svg{width:24px;height:24px;fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}' +
      '.fv-toast__title{margin:0;font-weight:900;font-size:16px;line-height:1.25}' +
      '.fv-toast__text{margin:2px 0 0;font-weight:600;font-size:14px;line-height:1.35;opacity:.95}' +
      '.fv-toast__close{flex:0 0 32px;height:32px;margin-left:4px;border:0;border-radius:50%;background:rgba(255,255,255,.18);color:#fff;cursor:pointer;display:grid;place-items:center;padding:0}' +
      '.fv-toast__close:hover{background:rgba(255,255,255,.3)}' +
      '.fv-toast__close svg{width:14px;height:14px;fill:none;stroke:currentColor;stroke-width:2.6;stroke-linecap:round}' +
      '.fv-toast__close:focus-visible{outline:3px solid #fff;outline-offset:2px}' +
      '@media (prefers-reduced-motion:reduce){.fv-toast{transition:none;transform:translate(-50%,0)}}' +
      '@media (max-width:749px){.fv-toast{bottom:16px;width:calc(100vw - 32px)}}' +
      /* cart drawer tag */
      '.fv-free-ship{display:inline-flex;align-items:center;gap:5px;margin-inline-start:10px;padding:4px 10px 4px 8px;border-radius:999px;' +
      'background:#E3F6EA;color:#1F7A43;font-family:Nunito,system-ui,-apple-system,sans-serif;font-weight:800;font-size:12px;line-height:1.2;' +
      'letter-spacing:0;text-transform:none;vertical-align:middle;white-space:nowrap;animation:fvPop .35s ease}' +
      '.fv-free-ship svg{width:15px;height:15px;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}' +
      '@keyframes fvPop{0%{transform:scale(.6);opacity:0}70%{transform:scale(1.08);opacity:1}100%{transform:scale(1)}}' +
      '@media (prefers-reduced-motion:reduce){.fv-free-ship{animation:none}}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* Add or remove the "Free shipping" pill next to the cart drawer title. */
  function applyFreeShipTag(total) {
    var heading = document.getElementById('cart-drawer-heading');
    if (!heading) return;
    var tag = heading.querySelector('.fv-free-ship');
    var qualifies = total !== null && total >= FREE_DELIVERY_THRESHOLD;
    /* Only on the filled cart heading (the empty-cart heading shares the same id). */
    var hasItems = !!heading.querySelector('.theme-drawer__badge');
    if (qualifies && hasItems) {
      if (!tag) {
        addFreeDeliveryStyles();
        tag = document.createElement('span');
        tag.className = 'fv-free-ship';
        tag.innerHTML = TRUCK_SVG + '<span>Free shipping</span>';
        heading.appendChild(tag);
      }
    } else if (tag) {
      tag.remove();
    }
  }

  /* Horizon re-renders the drawer contents on every cart change, which can drop the tag:
     re-apply it from the last known total whenever the drawer's DOM changes. */
  var tagFrame = null;
  function watchCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      if (tagFrame) return;
      tagFrame = requestAnimationFrame(function () {
        tagFrame = null;
        applyFreeShipTag(readTotal());
      });
    }).observe(drawer, { childList: true, subtree: true });
  }

  var toastTimer = null;
  function showFreeDeliveryToast() {
    addFreeDeliveryStyles();
    var old = document.querySelector('.fv-toast');
    if (old) old.remove();

    var toast = document.createElement('div');
    toast.className = 'fv-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="fv-toast__icon" aria-hidden="true">' + TRUCK_SVG + '</span>' +
      '<div><p class="fv-toast__title">You’ve unlocked free delivery!</p>' +
      '<p class="fv-toast__text">Your cart is over Rs 5,000, so shipping is on us.</p></div>' +
      '<button type="button" class="fv-toast__close" aria-label="Dismiss"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';

    /* Use the popover top layer when available so the toast sits above the open cart drawer. */
    var usePopover = typeof toast.showPopover === 'function';
    if (usePopover) toast.setAttribute('popover', 'manual');
    document.body.appendChild(toast);
    if (usePopover) { try { toast.showPopover(); } catch (e) {} }
    requestAnimationFrame(function () { requestAnimationFrame(function () { toast.classList.add('is-in'); }); });

    function close() {
      clearTimeout(toastTimer);
      toast.classList.remove('is-in');
      setTimeout(function () {
        if (usePopover) { try { toast.hidePopover(); } catch (e) {} }
        toast.remove();
      }, reduceMotion ? 0 : 320);
    }
    toast.querySelector('.fv-toast__close').addEventListener('click', close);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(close, 6000);
  }

  var checkQueued = null;
  function checkFreeDelivery(delay) {
    clearTimeout(checkQueued);
    checkQueued = setTimeout(function () {
      var r = routes();
      fetch(r.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var now = Number(cart.total_price) || 0;
          var before = readTotal();
          writeTotal(now);
          applyFreeShipTag(now);
          if (before !== null && before < FREE_DELIVERY_THRESHOLD && now >= FREE_DELIVERY_THRESHOLD) {
            showFreeDeliveryToast();
          }
        })
        .catch(function () {});
    }, delay || 0);
  }

  /* On every page load: sync the total and the drawer tag (a toast only appears if the
     total crossed the threshold since the last page, e.g. after adding on a product page). */
  function initFreeDelivery() {
    applyFreeShipTag(readTotal());
    watchCartDrawer();
    checkFreeDelivery(0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeDelivery);
  } else {
    initFreeDelivery();
  }

  /* Watch every cart change request made by the theme (add, change, update, clear). */
  var cartChange = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (cartChange.test(url)) {
      /* Quick tag update, then the toast check after the drawer has opened so it sits on top. */
      result.then(function () { checkFreeDelivery(reduceMotion ? 300 : 1400); }).catch(function () {});
    }
    return result;
  };

  /* ---------------------------------------------------------------
     4. Header pill celebration ("Pakistan's Best Online Toy Store").
        The pill and flag are drawn in CSS on the header's top row, so the
        pointer position is checked against the pill's box. On hover:
        the pill glows green and lifts a touch, a shine sweeps across it,
        the flag flutters faster, and a burst of confetti (Pakistan green
        and white-green, plus brand yellow, blue, coral and purple, with
        a few little stars) pops out of it. Desktop mouse only; the
        confetti is skipped when reduced motion is on.
     --------------------------------------------------------------- */
  (function () {
    var desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    var styled = false;
    function addPillStyles() {
      if (styled) return;
      styled = true;
      var s = document.createElement('style');
      s.textContent =
        '#header-component .header__row--top::before{transition:border-color .25s ease,background-color .25s ease,box-shadow .25s ease,transform .25s ease}' +
        '#header-component .header__row--top.fv-pk-hover::before{border-color:#8FD1A8;background-color:#E4F5EA;box-shadow:0 0 0 4px rgba(47,166,90,.14);transform:translateY(-50%) scale(1.03);animation:fvShineNow .9s ease-out 1}' +
        '#header-component .header__row--top.fv-pk-hover::after{animation-duration:.7s}' +
        '@keyframes fvShineNow{from{background-position:160% 0,0 0}to{background-position:-60% 0,0 0}}' +
        '.fv-confetti{position:fixed;left:0;top:0;display:block;pointer-events:none;z-index:2147483646;will-change:transform,opacity}' +
        '.fv-confetti svg{display:block;width:100%;height:100%}' +
        '@media (prefers-reduced-motion:reduce){#header-component .header__row--top.fv-pk-hover::before{animation:none;transform:translateY(-50%)}}';
      document.head.appendChild(s);
    }

    function pillBox(row) {
      var cs = getComputedStyle(row, '::before');
      if (!cs || cs.content === 'none' || cs.display === 'none') return null;
      var r = row.getBoundingClientRect();
      var w = parseFloat(cs.width) || 330;
      var h = parseFloat(cs.height) || 44;
      var left = r.left + (parseFloat(cs.left) || 0);
      var top = r.top + r.height / 2 - h / 2;
      return { left: left, top: top, width: w, height: h, right: left + w, bottom: top + h };
    }

    var COLORS = ['#01461F', '#2FA65A', '#A8E0BD', '#FFD62C', '#2F6FE0', '#F2665A', '#8E5BD9'];
    var STAR = '<svg viewBox="0 0 24 24"><path fill="#FFD62C" d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.6 7L12 17.3 5.8 20.9l1.6-7L2 9.2l7.1-.6z"/></svg>';
    function burst(p) {
      if (reduceMotion || !document.body.animate) return;
      for (var i = 0; i < 28; i++) {
        var el = document.createElement('span');
        el.className = 'fv-confetti';
        el.setAttribute('aria-hidden', 'true');
        var size = 5 + Math.random() * 5;
        if (i % 7 === 0) {
          size = 10 + Math.random() * 4;
          el.innerHTML = STAR;
          el.style.width = el.style.height = size + 'px';
        } else {
          var strip = i % 3 === 1;
          el.style.width = size + 'px';
          el.style.height = (strip ? size * 0.45 : size) + 'px';
          el.style.background = COLORS[i % COLORS.length];
          el.style.borderRadius = i % 3 === 0 ? '50%' : '1.5px';
        }
        document.body.appendChild(el);

        var ox = p.left + 16 + Math.random() * (p.width - 32);
        var oy = p.top + p.height / 2;
        var ang = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.5;
        var speed = 70 + Math.random() * 110;
        var vx = Math.cos(ang) * speed;
        var vy = Math.sin(ang) * speed;
        var spin = (Math.random() - 0.5) * 900;
        var frames = [];
        for (var k = 0; k <= 12; k++) {
          var t = k / 12;
          var x = ox + vx * t;
          var y = oy + vy * t + 240 * t * t;
          frames.push({
            transform: 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + (spin * t).toFixed(0) + 'deg) scale(' + (t < 0.1 ? 0.4 + t * 6 : 1) + ')',
            opacity: t < 0.7 ? 1 : 1 - (t - 0.7) / 0.3,
          });
        }
        var anim = el.animate(frames, { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(.2,.6,.4,1)', fill: 'forwards' });
        anim.onfinish = el.remove.bind(el);
        setTimeout(el.remove.bind(el), 2000);
      }
    }

    var over = false, lastBurst = 0, frame = 0, px = -1, py = -1;
    function check() {
      frame = 0;
      var row = document.querySelector('#header-component .header__row--top');
      if (!row) return;
      var p = desktop.matches ? pillBox(row) : null;
      var inside = !!p && px >= p.left && px <= p.right && py >= p.top && py <= p.bottom;
      if (inside) addPillStyles();
      if (row.classList.contains('fv-pk-hover') !== inside) row.classList.toggle('fv-pk-hover', inside);
      if (inside && !over && Date.now() - lastBurst > 1200) {
        lastBurst = Date.now();
        burst(p);
      }
      over = inside;
    }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      px = e.clientX;
      py = e.clientY;
      if (!frame) frame = requestAnimationFrame(check);
    }, { passive: true });
    document.addEventListener('mouseleave', function () { px = py = -1; check(); });
    window.addEventListener('scroll', function () { if (over && !frame) frame = requestAnimationFrame(check); }, { passive: true });
  })();
})();
